import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  analyticsApiRef,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  errorApiRef,
} from '@backstage/core-plugin-api';
import { visitsApiRef, VisitsWebStorageApi } from '@backstage/plugin-home';
import { scaffolderApiRef, ScaffolderClient } from '@backstage/plugin-scaffolder';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { TechRadarClient } from './tech-radar/TechRadarClient';
import { UsageAnalytics } from './components/usage';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  // El progreso de las solicitudes llega por long polling y no por eventstream: Backstage está detrás de un API Gateway
  // HTTP que corta a los 30 s y no deja pasar streaming, y la página nunca recibía el final de la tarea.
  createApiFactory({
    api: scaffolderApiRef,
    deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef, scmIntegrationsApi: scmIntegrationsApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, identityApi, scmIntegrationsApi, fetchApi }) =>
      new ScaffolderClient({ discoveryApi, identityApi, scmIntegrationsApi, fetchApi, useLongPollingLogs: true }),
  }),
  createApiFactory({
    api: visitsApiRef,
    deps: { identityApi: identityApiRef, errorApi: errorApiRef },
    factory: ({ identityApi, errorApi }) =>
      VisitsWebStorageApi.create({ identityApi, errorApi }),
  }),
  createApiFactory({
    api: techRadarApiRef,
    deps: {},
    factory: () => new TechRadarClient(),
  }),
  createApiFactory({
    api: analyticsApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) => new UsageAnalytics(discoveryApi, fetchApi),
  }),
];
